module.exports = __webpack_public_path__ + "img/3.628e2a3f.png";